'use es6';

import PropTypes from 'prop-types';
import { Children, PureComponent } from 'react';
import styled from 'styled-components';
import ThemeContext from '../../theming/contexts/ThemeContext';
import { jsx as _jsx } from "react/jsx-runtime";
const PaddedArea = styled.div.withConfig({
  displayName: "PrimaryMessageContentSection__PaddedArea",
  componentId: "sc-9c0xgg-0"
})(["padding:8px 16px;"]);
export const PrimaryMessageContentSectionWrapper = styled.div.withConfig({
  displayName: "PrimaryMessageContentSection__PrimaryMessageContentSectionWrapper",
  componentId: "sc-9c0xgg-1"
})(["overflow:hidden;width:100%;button{width:auto;}"]);
export default class PrimaryMessageContentSection extends PureComponent {
  renderContent() {
    const {
      children
    } = this.props;
    return /*#__PURE__*/_jsx(PaddedArea, {
      children: children
    });
  }
  render() {
    const {
      children,
      className
    } = this.props;
    const hasContent = Children.count(children) > 0;
    if (!hasContent) {
      return null;
    }
    return /*#__PURE__*/_jsx(PrimaryMessageContentSectionWrapper, {
      "data-test-id": "primary-message-content-section",
      className: className,
      children: /*#__PURE__*/_jsx("div", {
        className: "width-100 padding-x-4 padding-y-2",
        children: this.renderContent()
      })
    });
  }
}
PrimaryMessageContentSection.contextType = ThemeContext;
PrimaryMessageContentSection.displayName = 'PrimaryMessageContentSection';
PrimaryMessageContentSection.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};